var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useMemo, useLayoutEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { userLoginAction } from "../../reduxStore/actions/salesRepDataAction";
import { isAuthorized } from "../../services/behaviorSubjectService";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
import { regexPasswordValidation } from "../../shared/regex";
import { checkEmailValidation } from "../CustomerInvoice/Validation";
import { DEFAULT_FONT_FAMILY, DEFAULT_PRIMARY_COLOR, DEFAULT_BACKGROUND_COLOR } from "../Constant";
import { useFullScreenToggle } from "../../shared/Utilites";
export function LoginComponentBL() {
    var _this = this;
    var _a, _b;
    var t = useTranslation().t;
    var matchWidth = useMediaQuery("(min-width:930px");
    var DEFAULT_LOGIN_CUSTOMIZATION = {
        Theme: {
            FontFamily: DEFAULT_FONT_FAMILY,
            PrimaryColor: DEFAULT_PRIMARY_COLOR,
            BackgroundColor: DEFAULT_BACKGROUND_COLOR,
        },
        Pages: {
            Login: {
                Title: t("login_title"),
                Description: "Log in to manage orders, clients, and your business",
                Fields: [
                    { LabelName: t("login_email"), LabelKey: "email", SequenceNo: 0, IsVisible: true, IsRequired: true },
                    { LabelName: "Password", LabelKey: "password", SequenceNo: 1, IsVisible: true, IsRequired: true },
                ],
                Button: t("login_LogInBtn"),
            },
            ResetPassword: {
                Title: t("forgotPwd_title"),
                Description: "Enter your email to receive new password",
                Fields: [{ LabelName: t("login_email"), LabelKey: "email", SequenceNo: 0, IsVisible: true, IsRequired: true }],
                Button: t("forgotPwd_ResetBtn"),
            },
            Registration: {
                Title: t("registration_title"),
                Description: "Register to access your portal, manage accounts, and grow your business.",
                Fields: [
                    { LabelName: t("signUp_content2"), LabelKey: "firstName", SequenceNo: 0, IsVisible: true, IsRequired: true },
                    { LabelName: t("signUp_content3"), LabelKey: "lastName", SequenceNo: 1, IsVisible: true, IsRequired: true },
                    { LabelName: t("login_email"), LabelKey: "email", SequenceNo: 2, IsVisible: true, IsRequired: true },
                    { LabelName: t("signUp_content4"), LabelKey: "phone", SequenceNo: 3, IsVisible: true, IsRequired: true },
                    { LabelName: t("signUp_content5"), LabelKey: "facebook", SequenceNo: 4, IsVisible: true, IsRequired: false },
                    { LabelName: t("signUp_content7"), LabelKey: "instagram", SequenceNo: 5, IsVisible: true, IsRequired: false },
                    { LabelName: t("signup_linkedinHandle"), LabelKey: "linkedin", SequenceNo: 6, IsVisible: true, IsRequired: false },
                    { LabelName: t("signup_uploadProfilePhoto"), LabelKey: "profilePhoto", SequenceNo: 7, IsVisible: true, IsRequired: false },
                    { LabelName: t("signup_uploadCV"), LabelKey: "cv", SequenceNo: 8, IsVisible: true, IsRequired: false },
                    { LabelName: t("signup_coverMessage"), LabelKey: "coverLetter", SequenceNo: 9, IsVisible: true, IsRequired: false },
                ],
                Button: t("apply_btn_text"),
            },
        },
    };
    var dispatch = useDispatch();
    var _c = useState(0), index = _c[0], setIndex = _c[1];
    var _d = useState({ emailField: "", passwordField: "" }), formFields = _d[0], setFormFields = _d[1];
    var _e = useState({ emailErrMsg: "", passwordErrMsg: "" }), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = useState(true), loginUI = _f[0], setLoginUI = _f[1];
    var _g = useState(false), signupUI = _g[0], setSignupUI = _g[1];
    var _h = useState(false), forgotPasswordUI = _h[0], setForgotPasswordUI = _h[1];
    var loginBtnEnabled = ((_a = formFields.emailField) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = formFields.passwordField) === null || _b === void 0 ? void 0 : _b.length) > 0 && errorMessage.emailErrMsg === "" && errorMessage.passwordErrMsg === "";
    var _j = useState(""), userLoginErrMsg = _j[0], setUserLoginErrMsg = _j[1];
    var _k = useState(false), loginLoadingFlag = _k[0], setLoginLoadingFlag = _k[1];
    var _l = useState(false), showPassword = _l[0], setShowPassword = _l[1];
    var _m = useState(false), isSignupSuccess = _m[0], setIsSignupSuccess = _m[1];
    var _o = useFullScreenToggle(), fullScreen = _o.fullScreen, toggleFullScreen = _o.toggleFullScreen;
    // When the Shopify storefront header/footer are visible (!fullScreen), the login box renders
    // below them in normal page flow, so a plain 100vh height would overflow past the viewport bottom
    // and its centered content would sit lower than the visible area's true center. Measure how far
    // down the box actually starts and size it to exactly fill the remaining visible viewport instead.
    var scopeRef = useRef(null);
    var _p = useState(0), scopeTopOffset = _p[0], setScopeTopOffset = _p[1];
    useLayoutEffect(function () {
        var _a, _b;
        var updateOffset = function () {
            if (scopeRef.current) {
                setScopeTopOffset(scopeRef.current.getBoundingClientRect().top);
            }
        };
        updateOffset();
        window.addEventListener("resize", updateOffset);
        // Storefront chrome above the login box (webfonts swapping in, announcement bars
        // collapsing, images loading) can reflow after this effect first measures the offset,
        // without ever firing a window "resize" event. Re-measure on any such reflow so the
        // login box doesn't get stuck sized against a stale, pre-reflow offset.
        var resizeObserver = new ResizeObserver(updateOffset);
        resizeObserver.observe(document.body);
        (_b = (_a = document.fonts) === null || _a === void 0 ? void 0 : _a.ready) === null || _b === void 0 ? void 0 : _b.then(updateOffset);
        return function () {
            window.removeEventListener("resize", updateOffset);
            resizeObserver.disconnect();
        };
    }, [fullScreen, matchWidth]);
    // Customization state
    var _q = useState(DEFAULT_LOGIN_CUSTOMIZATION), config = _q[0], setConfig = _q[1];
    var fontFamily = useMemo(function () { var _a; return ((_a = config.Theme) === null || _a === void 0 ? void 0 : _a.FontFamily) || DEFAULT_LOGIN_CUSTOMIZATION.Theme.FontFamily; }, [config]);
    var backgroundColor = useMemo(function () { var _a; return ((_a = config.Theme) === null || _a === void 0 ? void 0 : _a.BackgroundColor) || DEFAULT_LOGIN_CUSTOMIZATION.Theme.BackgroundColor; }, [config]);
    var primaryColor = useMemo(function () { var _a; return ((_a = config.Theme) === null || _a === void 0 ? void 0 : _a.PrimaryColor) || DEFAULT_LOGIN_CUSTOMIZATION.Theme.PrimaryColor; }, [config]);
    // Load Google Font dynamically for provided fontFamily (if any)
    useEffect(function () {
        webFontHandler(fontFamily);
    }, [fontFamily]);
    // Inject scoped CSS with !important to override fonts on login screen (fallback to Inter)
    useEffect(function () {
        var styleId = applyScopedFontCss(fontFamily);
        return function () {
            var existing = document.getElementById(styleId);
            if (existing && existing.parentElement)
                existing.parentElement.removeChild(existing);
        };
    }, [fontFamily]);
    useEffect(function () {
        var salesteam_bo_props = window.salesteam_bo_props;
        var loginCustomization = salesteam_bo_props === null || salesteam_bo_props === void 0 ? void 0 : salesteam_bo_props.loginCustomization;
        var parsedLoginCustomization = safeParse(loginCustomization);
        if (parsedLoginCustomization && parsedLoginCustomization.Theme && parsedLoginCustomization.Pages) {
            var merged = customizedLoginDeepMerge(DEFAULT_LOGIN_CUSTOMIZATION, parsedLoginCustomization);
            setConfig(merged);
        }
    }, []);
    // Handle signup success state change
    var handleSignupSuccessChange = function (isSuccess) {
        setIsSignupSuccess(isSuccess);
    };
    var handleChange = function (currentIndex) {
        setIndex(currentIndex);
    };
    var handleKeyDown = function (event) {
        var _a;
        var fieldName = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.name) || "";
        var key = event.key || "";
        var keyCode = event.keyCode || 0;
        // Null check for fieldName
        if (fieldName === "" || fieldName == null) {
            return;
        }
        // Prevent space character in password field
        if (fieldName === "passwordField" && key === " ") {
            event.preventDefault();
            return;
        }
        if (key === "Enter" && keyCode === 13 && loginBtnEnabled) {
            userLogin();
        }
    };
    var changeFieldsValue = function (e) {
        var _a;
        var _b;
        var _c = (_b = e.target) !== null && _b !== void 0 ? _b : {}, name = _c.name, value = _c.value;
        if (!name || value == null)
            return;
        var processedValue = name === "passwordField" ? value.replace(/\s/g, "") : value;
        setFormFields(__assign(__assign({}, formFields), (_a = {}, _a[name] = processedValue, _a)));
        fieldsValidation(name, processedValue);
    };
    var fieldsValidation = function (name, value) {
        if (name === "emailField") {
            value === ""
                ? setErrorMessage(function (values) { return (__assign(__assign({}, values), { emailErrMsg: t("required_ErrorMsg") })); })
                : checkEmailValidation(value.trim())
                    ? setErrorMessage(function (values) { return (__assign(__assign({}, values), { emailErrMsg: t("emailValidation_ErrorMsg") })); })
                    : setErrorMessage(function (values) { return (__assign(__assign({}, values), { emailErrMsg: "" })); });
        }
        if (name === "passwordField") {
            value === ""
                ? setErrorMessage(function (values) { return (__assign(__assign({}, values), { passwordErrMsg: t("required_ErrorMsg") })); })
                : value.match(regexPasswordValidation)
                    ? setErrorMessage(function (values) { return (__assign(__assign({}, values), { passwordErrMsg: "" })); })
                    : setErrorMessage(function (values) { return (__assign(__assign({}, values), { passwordErrMsg: "Password should contain minimum 8 characters,1 uppercase,1 lowercase,1 digit etc." })); });
        }
    };
    var handlePaste = function (event) {
        var _a;
        var _b;
        var fieldName = (_b = event.target) === null || _b === void 0 ? void 0 : _b.name;
        var clipboardData = event === null || event === void 0 ? void 0 : event.clipboardData;
        // Null check for fieldName
        if (fieldName == null) {
            return;
        }
        // Prevent spaces from being pasted in password field
        if (fieldName === "passwordField") {
            event.preventDefault();
            var pastedText = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData("text");
            var cleanedText = (pastedText === null || pastedText === void 0 ? void 0 : pastedText.replace(/\s/g, "")) || "";
            // Update the field with cleaned text
            setFormFields(__assign(__assign({}, formFields), (_a = {}, _a[fieldName] = cleanedText, _a)));
            fieldsValidation(fieldName, cleanedText);
        }
    };
    var userLogin = function () { return __awaiter(_this, void 0, void 0, function () {
        var loginResponse, jsonString, encodedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoginLoadingFlag(true);
                    return [4 /*yield*/, dispatch(userLoginAction(formFields))];
                case 1:
                    loginResponse = _a.sent();
                    if (loginResponse.status == 200) {
                        jsonString = JSON.stringify(loginResponse);
                        encodedData = btoa(unescape(encodeURIComponent(jsonString)));
                        sessionStorage.setItem("Authorization", encodedData);
                        setLoginLoadingFlag(false);
                        setFormFields({ emailField: "", passwordField: "" });
                        isAuthorized.next(true);
                    }
                    else if (loginResponse.status == 500) {
                        setUserLoginErrMsg(loginResponse.message);
                        setLoginLoadingFlag(false);
                        setTimeout(function () {
                            setUserLoginErrMsg("");
                        }, 15000);
                    }
                    setLoginLoadingFlag(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var toggleUI = function (data) {
        switch (data) {
            case 1:
                setFormFields({ emailField: "", passwordField: "" });
                setErrorMessage({ emailErrMsg: "", passwordErrMsg: "" });
                setLoginUI(true);
                setSignupUI(false);
                setForgotPasswordUI(false);
                break;
            case 2:
                setSignupUI(true);
                setLoginUI(false);
                setForgotPasswordUI(false);
                break;
            case 3:
                setForgotPasswordUI(true);
                setLoginUI(false);
                setSignupUI(false);
                break;
        }
    };
    var handleClickShowPassword = function () {
        setShowPassword(!showPassword);
    };
    var safeParse = function (jsonString) {
        if (!jsonString)
            return undefined;
        try {
            return JSON.parse(jsonString);
        }
        catch (err) {
            return undefined;
        }
    };
    // Healper methods
    // Deeply merges default customization with overrides from window props.
    // Arrays: replace when override has items; Objects: merge recursively; Primitives: override when defined.
    var customizedLoginDeepMerge = function (base, overrideObj) {
        if (!overrideObj)
            return base;
        var output = Array.isArray(base) ? __spreadArray([], base, true) : __assign({}, base);
        Object.keys(overrideObj).forEach(function (key) {
            var baseVal = output[key];
            var overrideVal = overrideObj[key];
            if (Array.isArray(baseVal) && Array.isArray(overrideVal)) {
                // If override array is non-empty, replace, otherwise keep base
                output[key] = overrideVal.length ? overrideVal : baseVal;
            }
            else if (baseVal && typeof baseVal === "object" && !Array.isArray(baseVal) && overrideVal && typeof overrideVal === "object" && !Array.isArray(overrideVal)) {
                output[key] = customizedLoginDeepMerge(baseVal, overrideVal);
            }
            else if (overrideVal !== undefined) {
                output[key] = overrideVal;
            }
        });
        return output;
    };
    // Loads a Google Fonts <link> only for non-system fonts to avoid unnecessary network requests.
    // Ensures one link element per font family by generating a stable id per font value.
    var webFontHandler = function (selectedFontFamily) {
        try {
            var raw = (selectedFontFamily || "").trim();
            if (!raw)
                return;
            // SSR/DOM guards
            if (typeof document === "undefined" || !document)
                return;
            var headEl = (document.head || document.getElementsByTagName("head")[0]);
            if (!headEl)
                return;
            // Normalize: take the primary family from a comma-separated list and strip quotes
            var primary = raw
                .split(",")
                .map(function (token) { return token.trim().replace(/^['"]|['"]$/g, ""); })
                .find(function (v) { return v.length > 0; }) || "";
            if (!primary)
                return;
            // Skip loading for common system fonts (normalized to lowercase)
            var normalized = primary.toLowerCase();
            var systemFonts = new Set([
                "arial",
                "helvetica",
                "times new roman",
                "times",
                "georgia",
                "courier new",
                "courier",
                "segoe ui",
                "tahoma",
                "verdana",
                "trebuchet ms",
                "system ui",
                "sans-serif",
                "serif",
            ]);
            if (systemFonts.has(normalized))
                return;
            var id = "dynamic-font-".concat(normalized.replace(/\s+/g, "-"));
            if (document.getElementById(id))
                return;
            var link = document.createElement("link");
            if (!link)
                return;
            link.id = id;
            link.rel = "stylesheet";
            // Use encodeURIComponent to safely encode multi-word families
            link.href = "https://fonts.googleapis.com/css2?family=".concat(encodeURIComponent(primary), ":wght@400;500;700&display=swap");
            headEl.appendChild(link);
        }
        catch (_err) {
            // Non-fatal: ignore optional font loading errors
            return;
        }
    };
    // Applies a scoped font-family override to the login UI to reliably beat global styles.
    // Falls back to 'Inter' when no font is provided. Returns the injected style element id for cleanup.
    var applyScopedFontCss = function (selectedFontFamily) {
        try {
            var provided = (selectedFontFamily || "").trim();
            var id = "ST_Login_Scope-css-".concat(provided.replace(/\s+/g, "-").toLowerCase() || "default");
            // SSR/DOM guards
            if (typeof document === "undefined" || !document)
                return id;
            var chosenFamily = provided || "Inter";
            var safeFamily = chosenFamily.replace(/"/g, '\\"').replace(/'/g, "\\'");
            var css = ".ST_Login_Scope * { font-family: '".concat(safeFamily, "', Arial, sans-serif !important; }");
            // Remove any previous injected styles for login scope to avoid duplicates
            document.querySelectorAll("style[id^='ST_Login_Scope-css-']").forEach(function (el) { return el.parentElement && el.parentElement.removeChild(el); });
            var styleEl = document.getElementById(id);
            if (!styleEl) {
                styleEl = document.createElement("style");
                styleEl.id = id;
                var headEl = (document.head || document.getElementsByTagName("head")[0]);
                if (headEl)
                    headEl.appendChild(styleEl);
            }
            if (styleEl && styleEl.textContent !== css)
                styleEl.textContent = css;
            return id;
        }
        catch (_err) {
            return "ST_Login_Scope-css-default";
        }
    };
    return {
        t: t,
        // customization
        config: config,
        fontFamily: fontFamily,
        backgroundColor: backgroundColor,
        primaryColor: primaryColor,
        // login states and handlers
        index: index,
        setIndex: setIndex,
        handleChange: handleChange,
        formFields: formFields,
        errorMessage: errorMessage,
        changeFieldsValue: changeFieldsValue,
        userLogin: userLogin,
        loginBtnEnabled: loginBtnEnabled,
        loginUI: loginUI,
        signupUI: signupUI,
        forgotPasswordUI: forgotPasswordUI,
        toggleUI: toggleUI,
        userLoginErrMsg: userLoginErrMsg,
        loginLoadingFlag: loginLoadingFlag,
        matchWidth: matchWidth,
        handleKeyDown: handleKeyDown,
        handlePaste: handlePaste,
        showPassword: showPassword,
        handleClickShowPassword: handleClickShowPassword,
        handleSignupSuccessChange: handleSignupSuccessChange,
        isSignupSuccess: isSignupSuccess,
        fullScreen: fullScreen,
        toggleFullScreen: toggleFullScreen,
        scopeRef: scopeRef,
        scopeTopOffset: scopeTopOffset,
    };
}
